import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData, Fn_DeleteData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { toast } from "react-toastify";
import useSession from "../utils/useSession";

const ExtraPaySchema = Yup.object().shape({
  ExtraPayName: Yup.string().required("Extra Pay name is required"),
  F_FirmMaster: Yup.number().required("Firm is required"),
  Ordering: Yup.string(),
});

const AddEdit_ExtraPayMaster = () => {
  const { firmId: sessionFirmId } = useSession();
  const defaultFirmId = sessionFirmId ? String(sessionFirmId) : "";

  const [state, setState] = useState({
    id: 0,
    formData: {
      ExtraPayName: "",
      F_FirmMaster: defaultFirmId,
      Ordering: "",
      IsActive: true,
      PFOnExtraPay: false,
      ESIOnExtraPay: false,
    },
    FirmMaster: [],
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "ExtraPayMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/ExtraPayMaster/Id`;

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FirmMaster", `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`);
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    } else {
      setState((prev) => ({
        ...prev,
        formData: {
          ...prev.formData,
          F_FirmMaster: defaultFirmId,
        },
      }));
    }
  }, [dispatch, location.state, defaultFirmId]);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("ExtraPayName", values.ExtraPayName);
      formData.append("F_FirmMaster", values.F_FirmMaster || defaultFirmId || 0);
      formData.append("Ordering", values.Ordering);
      formData.append("IsActive", values.IsActive ? true : false);
      formData.append("PFOnExtraPay", values.PFOnExtraPay ? true : false);
      formData.append("ESIOnExtraPay", values.ESIOnExtraPay ? true : false);

      Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/ExtraPayMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Extra Pay Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Extra Pay Master</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize
                  validationSchema={ExtraPaySchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      handleSubmit(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Extra Pay Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="ExtraPayName"
                            value={values.ExtraPayName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.ExtraPayName && <div className="text-danger fs-12">{errors.ExtraPayName}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">
                            Firm * {defaultFirmId ? <span className="badge bg-light text-success ms-1 border" style={{ fontSize: "11px" }}>🔒 Header Locked</span> : null}
                          </label>
                          <select
                            className="form-control"
                            name="F_FirmMaster"
                            value={values.F_FirmMaster || defaultFirmId}
                            disabled={!!defaultFirmId}
                            style={defaultFirmId ? { backgroundColor: "#f8f9fa", cursor: "not-allowed" } : {}}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Firm --</option>
                            {state.FirmMaster.map((f) => <option key={f.Id} value={f.Id}>{f.Name}</option>)}
                          </select>
                          {errors.F_FirmMaster && <div className="text-danger fs-12">{errors.F_FirmMaster}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Ordering</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Ordering"
                            value={values.Ordering}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.Ordering && <div className="text-danger fs-12">{errors.Ordering}</div>}
                        </div>

                        <div className="col-md-6 mb-3 d-flex align-items-center mt-4">
                          <div className="form-check me-4">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsActive"
                              name="IsActive"
                              checked={!!values.IsActive}
                              onChange={(e) => setFieldValue("IsActive", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsActive">
                              Is Active
                            </label>
                          </div>
                          <div className="form-check me-4">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="PFOnExtraPay"
                              name="PFOnExtraPay"
                              checked={!!values.PFOnExtraPay}
                              onChange={(e) => setFieldValue("PFOnExtraPay", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="PFOnExtraPay">
                              PF on Extra Pay
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="ESIOnExtraPay"
                              name="ESIOnExtraPay"
                              checked={!!values.ESIOnExtraPay}
                              onChange={(e) => setFieldValue("ESIOnExtraPay", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="ESIOnExtraPay">
                              ESI on Extra Pay
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        {state.id > 0 && (
                          <button
                            type="button"
                            className="btn btn-danger me-2"
                            onClick={async () => {
                              if (window.confirm(`Are you sure you want to delete extra pay "${values.ExtraPayName || state.id}"?`)) {
                                try {
                                  await Fn_DeleteData(dispatch, () => {}, Number(state.id), `${API_WEB_URLS.MASTER}/0/token/ExtraPayMaster`);
                                  toast.success("Extra pay deleted successfully");
                                  navigate("/ExtraPayMaster");
                                } catch (err) {
                                  console.error("Error deleting extra pay:", err);
                                }
                              }
                            }}
                          >
                            Delete
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger light"
                          onClick={() => navigate("/ExtraPayMaster")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_ExtraPayMaster;
